import React from 'react';
import ReportDataSummary from "../report/redesigned/ReportDataSummary";
import DownloadCSVButton from "../report/export/DownloadCSVButton";
import { getReadyForPayoutGroupSummaryReportUrl, getReadyForPayoutReportUrl } from "../../views/requests/account-report";
import { Grid, useMediaQuery } from "@mui/material";
import {Theme} from "@mui/material/styles";

interface QueryParams {
  locationId?: string,
  sortBy?: string,
  sortDir?: string
}

interface PayoutReportDataSummaryProps {
  query: QueryParams;
  count: number,
  title: string
}

/**
 * Displays a summary of the Payout Report. Includes buttons to download the report and report as a group summary in CSV format.
 *
 * @prop {Object} query - The query parameters for the report, including locationId, sortBy, and sortDir.
 * @prop {number} count - The count of items in the report.
 * @prop {string} title - The title of the report summary.
 */
const PayoutReportDataSummary= ({query, count, title}: PayoutReportDataSummaryProps) => {
  const isLgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  return (
    <ReportDataSummary count={count} title={title}>
      <Grid item container lg xs={12} gap={2} justifyContent={isLgUp ? 'end' : 'start'} wrap={isLgUp ? 'nowrap' : 'wrap'}>
        <Grid item>
          <DownloadCSVButton
            title={'Download Report'}
            reportUrl={getReadyForPayoutReportUrl(query)}
          />
        </Grid>
        <Grid item>
          <DownloadCSVButton
            title={'Export Group Summary'}
            reportUrl={getReadyForPayoutGroupSummaryReportUrl(query)}
          />
        </Grid>
      </Grid>
    </ReportDataSummary>
  )
};

export default PayoutReportDataSummary;
